<template>
		<div>
			
				<b-row class="mb-3" v-if="business.kyc_agree==0">
			
					<b-col lg="12" sm="12">
						<!-- <small>Step 1:</small> -->
					<h6><small>Please agree to the terms of Agreement to start selling on Alluraa</small></h6>  
						<b-card>
							
						<b-link class="mr-4"  v-b-modal.selleragreementpopup download="download" > 
						<i class="fa fa-file-text-o" style="font-size:18px"></i>
						Agreement Copy</b-link><p class="agreecopy">(Click the link to read the agreement)</p> 
						
						<div style="font-size: 15px;margin-top: 10px;">I have read the agreement and accept <b-form-checkbox size="lg" v-model="kycAgreement" id="kycAgreement-a"  value="1" class="tickAgrimet" @change="checkAgriment($event)"></b-form-checkbox> </div>
						<div class="pcb"><span>(Please Check the Box)</span></div>
						
						</b-card>
						
						
					</b-col>
				</b-row>
				<b-row class="mb-3" v-else>
			
					<b-col lg="12" sm="12">
						<!--<small>Step 1:</small> -->

						<b-card>
							
							<div style="font-size: 15px;margin-top: 10px;">You have already accepted the terms of Agreement.  <b-icon icon="check-square" scale="1.5" variant="success" class="ml-2"></b-icon>
							
							
							<!--<b-form-checkbox size="lg" id="kycAgreement-b"  class="agrApp" disabled="true" checked="true" variant="success" ></b-form-checkbox> -->
							</div>
						</b-card>
						<b-row style="margin-left: 1px;">
								<b-col  class="p-0" lg="5"><small><b-link v-b-modal.selleragreementpopup download="download" >  <b-icon icon="eye" aria-hidden="true"></b-icon> View Agreement   </b-link>
							</small></b-col>
								<b-col class="pr-0" style="border-left: 1px solid #c6c6c661;"><small><b-link href="https://www.alluraa.com/media/kyc/seller_agreeement_alluraa.pdf"  download="download" target="_blank">  <b-icon icon="download" aria-hidden="true"></b-icon>  Download Agreement	 </b-link>
							</small></b-col>
							</b-row>
						
						
						 
							

					</b-col>
				</b-row>
				<b-modal id="selleragreementpopup" title="Seller Agreement"   ok-only   hide-footer  size="lg" centered>
				
				<iframe id="iframepdf" type='application/pdf'  src="https://www.alluraa.com/media/kyc/seller_agreeement_alluraa.pdf#view=FitH&scrollbar=0&toolbar=0&statusbar=0&messages=0&navpanes=0" width="100%" height="330px" allowtransparency="true"  style="background: #FFFFFF;border:0px;" frameBorder="0" ></iframe> 
				
				<b-row class="my-2" v-if="business.kyc_agree==0">
					<b-col class="text-center">
						<b-button variant="secondary" size="sm" class="mr-5" @click="$bvModal.hide('selleragreementpopup')">DECLINE</b-button>
						 <b-button variant="success" size="sm" @click="iageryTnc">I AGERE</b-button>
					</b-col>
				</b-row>
			  </b-modal>
				
		</div>
	</template>
<script>
//import Selleragreeementpopup from "@/components/selleragreement-popup.vue";
//import CartVariant from "@/components/cartVariant.vue";
export default {
  name: 'ProfileBusiness',
  components: {
  //"cart-variant": CartVariant,
  //"selleragreement-popup": Selleragreeementpopup,
  },
  props: {
   /* profile: { type: Object },
    cartData: { type: Object  }, 
	cartTotalqty:Number,*/
  },
  mounted(){
  this.inLodcard();
  //this.initProfile();
  
  },
  computed: {
    //
  },
  data() {
    return{
		recordUrl: this.$root.NEWAPIURL+'profileapi/load-business',
		//uploadBusUrl: this.$root.NEWAPIURL+'profileapi/upload_profilebusiness', 
		uploadBusUrl: this.$root.NEWAPIURL+'profileapi/upload_kycdocument_seller', 
		//uploadCSUrl: this.$root.NEWAPIURL+'profileapi/upload_profilecustomersupport', 
		editField : '',
		addOfficeaddress:0,
		kycAgreement:0,
		business:{
				business_logo:'',
				seller_upload_kyc:'',
				seller_upload_kyc_date:'',
				seller_upload_kyc_verify:'',
				seller_upload_kyc_verify_date:'',
				kyc_agree:0,
			},
		businessState:{
			business_logo:null,
			
		},
		shippingaddress:{},
		product_inf:{},
		thumbnailProps: { blank: false, width: 80, height: 80, class: 'm1' },
		editLogo:0,
		customerSupport:0,
		csContact:{
			cs_email:'',
			cs_phone:''
		},
		cscontactState:{
			cs_email:null,
			cs_phone:null
			
		},
		csContactError:{
			cs_email:null,
			cs_phone:'Please enter Phone number!',
			
		},
		
		
	}
  },
  methods:{
	inLodcard(){
			var self = this;			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					var tmp = response.data.result;
					
					//console.log('Muygahs'+tmp);
					if(tmp!=null){
					self.business = Object.assign({}, tmp);
					}
					
					if(self.business.office_address!=''){
					self.addOfficeaddress=1;
					}
					if(self.business.business_logo!= null){
						self.editLogo=1;
					}
					if(tmp!=null){					
					self.csContact = Object.assign({}, tmp.csdetails);
					}
					
					
					//self.loading = false;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
		
	},
	saveProfile(){
		//alert('len'+this.shippingaddress.firstname.length);
		var valid = true;
		//console.log('dev'+this.product_inf.product_image_1);
		/*if (typeof(this.product_inf.product_image_1) == "undefined"){
			this.businessState.business_logo = false;
			valid = false;
		}else{
			this.businessState.business_logo = true;
		} */
		
		
		

		if(valid){
			var self = this;
			
			
			let formData = new FormData();
			formData.append('imagefile1', this.product_inf.product_image_1);	
            formData.append('accesskey', this.$session.get('access_key'));

            self.axios.post(self.uploadBusUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//console.log("ddd"+response.data);
					//self.shippingaddressData = response.data.result.shippingaddressData;
					//self.showAddaddress=0;
					
					self.business={
						
						business_logo:'',
						
					};
					self.businessState={
						business_logo:null,
						
					};
					
					self.inLodcard();
					//self.$root.resetCart();
					//self.$router.push('/order-success');
					//console.log(self.share_data);
					//alert(response.data.message);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}else{
					alert(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
		}
		

	},
	checkAgriment(e){
		console.log(e+'agre'+this.kycAgreement);
		if(e==1){
			console.log('xss'+this.kycAgreement);
			this.saveProfile();
		}
		
	
	},
	iageryTnc(){
		this.saveProfile();
		this.$bvModal.hide('selleragreementpopup');
	}
	
	


    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   lang="scss">
.col-form-label-sm{
padding:0px;
margin:0px;}

.agreecopy{
	color: red !important;
    padding: 0;
    margin: 0px;
    line-height: 7px;
    font-size: 12px;
}
.tickAgrimet{
	margin-top: -3px;
	float: right;
}
.agrApp{
	width: 10px;
    float: right;
    top: -3px;
	position: absolute;
    margin-top: 38px;
    right: 163px;
	.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before{
	    background-color: green !important;
	}
	&::before{
	    background-color: green !important;
	}
}

#selleragreementpopup{
			.modal-body{
			padding:0px 8px 10px 8px !important;
			}
			.modal{
				&-header{
				padding: 5px 5px 5px 15px;
				}
			
			}
			
		}
		
		.pcb{
		line-height: 16px;
		font-size: 11px;
		text-align: right;
		color:red;
			span{
			margin-right: -33px;
			}
		}

</style>
